import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import appIcon from './assets/website_logo_circular.png';

// Set favicon and apple-touch-icon using bundled asset
(() => {
  try {
    const head = document.head || document.getElementsByTagName('head')[0];
    // remove any existing icons to avoid duplicates
    document
      .querySelectorAll('link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]')
      .forEach((el) => el.parentNode && el.parentNode.removeChild(el));

    const addIcon = (rel, sizes) => {
      const link = document.createElement('link');
      link.rel = rel;
      if (sizes) link.sizes = sizes;
      link.type = 'image/png';
      link.href = appIcon;
      head.appendChild(link);
    };

    addIcon('icon');
    addIcon('shortcut icon');
    addIcon('apple-touch-icon');
  } catch (err) {
    // ignore: favicon is non-critical
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);